module.exports = __webpack_public_path__ + "static/media/admin-percent.005b543f.svg";